<mat-card class="decoration-card">
    <mat-card-content>
        <!--mat-toolbar>
            <button mat-icon-button class="example-icon" aria-label="Example icon-button with menu icon">
                <mat-icon>edit</mat-icon>
            </button>
            <span></span>
            <span class="example-spacer"></span>
            <button mat-icon-button class="example-icon favorite-icon" aria-label="Example icon-button with heart icon">
                <mat-icon>favorite</mat-icon>
            </button>
            <button mat-icon-button class="example-icon" aria-label="Example icon-button with share icon">
                <mat-icon>share</mat-icon>
            </button>
        </mat-toolbar-->

        <div class="customer-list">
            <div *ngFor="let customer of customers">
                <mat-card appearance="outlined" class="customer-card" [class.isWithEditRight]="customer.user_role !== 3" (click)="selectCustomer(customer)">
                    <mat-card-header>
                        <img mat-card-avatar [src]="customer.icon" alt="Img">
                        <mat-card-title>{{customer.name}}</mat-card-title>
                        <mat-card-subtitle>{{customer.description}}</mat-card-subtitle>
                    </mat-card-header>
                </mat-card>
            </div>
        </div>

    </mat-card-content>
</mat-card>